import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from "vue";
import {
  CODE_THEME_STORE,
  set_code_theme,
  init_code_theme_from_system,
} from "./code_theme_store";


export default /*#__PURE__*/_defineComponent({
  __name: 'code_theme_toggle',
  setup(__props) {

const is_code_theme_dark = computed(
  () => CODE_THEME_STORE.current_code_theme === "dark",
);

const switch_code_theme = () => {
  set_code_theme(is_code_theme_dark.value ? "light" : "dark");
};

onMounted(() => {
  init_code_theme_from_system();
});

return { __sfc: true,is_code_theme_dark, switch_code_theme }
}

})